var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFAE00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524 1841v30.392h15.67c1.907 0 3.602.376 4.428 1.608v-29.978c-.8-1.347-2.49-2.022-4.427-2.022H524zm25.505 0c-1.937 0-3.628.675-4.427 2.022V1873c.826-1.232 2.52-1.608 4.427-1.608h15.67V1841h-15.67zm-21.093 5.392h11.764c.542 0 .98.439.98.98 0 .542-.438.98-.98.98h-11.764c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm20.588 0h11.764c.541 0 .98.439.98.98 0 .542-.439.98-.98.98H549c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm-20.588 4.412h11.764c.542 0 .98.439.98.98 0 .542-.438.98-.98.98h-11.764c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm20.588 0h11.764c.541 0 .98.439.98.98 0 .542-.439.98-.98.98H549c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm-20.588 4.411h11.764c.542 0 .98.44.98.98 0 .542-.438.981-.98.981h-11.764c-.542 0-.98-.439-.98-.98 0-.542.438-.98.98-.98zm20.588 0h11.764c.541 0 .98.44.98.98 0 .542-.439.981-.98.981H549c-.542 0-.98-.439-.98-.98 0-.542.438-.98.98-.98zm-20.588 4.412h11.764c.542 0 .98.439.98.98 0 .542-.438.98-.98.98h-11.764c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm20.588 0h11.764c.541 0 .98.439.98.98 0 .542-.439.98-.98.98H549c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm-20.588 4.412h11.764c.542 0 .98.439.98.98 0 .542-.438.98-.98.98h-11.764c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98zm20.588 0h11.764c.541 0 .98.439.98.98 0 .542-.439.98-.98.98H549c-.542 0-.98-.438-.98-.98 0-.541.438-.98.98-.98z",
    transform: "translate(-524 -1841)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEducation);
export default __webpack_public_path__ + "static/media/icon-education.2d3dc7e3cff024367c84fe3606dba108.svg";
export { ForwardRef as ReactComponent };